export default __webpack_public_path__ + "static/media/Home_01.db463713.png";